(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('cart:updated', (event) => {
    const label = document.querySelector('.header__cart-label');
    if (!label || !event.detail || typeof event.detail.itemCount !== 'number') return;
    label.textContent = label.textContent.replace(/\d+/, String(event.detail.itemCount));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-protocol"] && !Shopify.designMode) return;
  try {
    
  class ProductQuickShop extends HTMLElement {
    connectedCallback() {
      this.stageImage = this.querySelector('[data-role="stage-image"]');
      this.counter = this.querySelector('[data-role="counter"]');
      this.thumbs = Array.from(this.querySelectorAll('[data-role="thumb"]'));
      this.priceEl = this.querySelector('[data-role="price"]');
      this.variantIdInput = this.querySelector('[data-role="variant-id"]');
      this.submitBtn = this.querySelector('[data-role="submit"]');
      this.form = this.querySelector('[data-role="form"]');
      this.formMessage = this.querySelector('[data-role="form-message"]');
      this.index = 0;

      const prev = this.querySelector('[data-role="prev"]');
      const next = this.querySelector('[data-role="next"]');
      if (prev) prev.addEventListener('click', () => this.setIndex(this.index - 1));
      if (next) next.addEventListener('click', () => this.setIndex(this.index + 1));

      this.thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => this.setIndex(parseInt(thumb.dataset.index, 10)));
      });

      this.querySelectorAll('[data-role="variant-input"]').forEach((input) => {
        input.addEventListener('change', () => this.applyVariant(input));
      });

      if (this.form) {
        this.form.addEventListener('submit', (event) => this.handleSubmit(event));
      }
    }

    setIndex(newIndex) {
      const count = this.thumbs.length;
      if (!count) return;
      this.index = (newIndex + count) % count;
      const thumb = this.thumbs[this.index];
      if (this.stageImage && thumb) {
        this.stageImage.src = thumb.dataset.full;
        const thumbImg = thumb.querySelector('img');
        if (thumbImg) this.stageImage.alt = thumbImg.alt;
        thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
      this.thumbs.forEach((t, i) => t.classList.toggle('protocol__thumb--active', i === this.index));
      if (this.counter) this.counter.textContent = (this.index + 1) + ' / ' + count;
    }

    applyVariant(input) {
      if (this.priceEl) this.priceEl.innerHTML = this.buildPriceHtml(input.dataset.priceHtml, input.dataset.comparePriceHtml);
      if (this.variantIdInput) this.variantIdInput.value = input.value;
      const available = input.dataset.available === 'true';
      if (this.submitBtn) {
        this.submitBtn.disabled = !available;
        this.submitBtn.textContent = available
          ? this.submitBtn.dataset.labelAvailable
          : this.submitBtn.dataset.labelUnavailable;
      }
    }

    // Mirrors snippets/price.liquid's own markup/classes exactly, so a
    // variant switch and the initial server render look identical —
    // comparePriceHtml is only ever a plain already-money-formatted
    // string (or empty), never raw variant data, so no separate
    // escaping is needed here.
    buildPriceHtml(priceHtml, comparePriceHtml) {
      let html = '<span class="price__amount">' + (priceHtml || '') + '</span>';
      if (comparePriceHtml) {
        html += '<del class="price__compare-at">' + comparePriceHtml + '</del>';
      }
      return html;
    }

    async handleSubmit(event) {
      event.preventDefault();
      if (!this.submitBtn || this.submitBtn.disabled) return;

      const originalLabel = this.submitBtn.dataset.labelAvailable;
      this.submitBtn.disabled = true;
      this.submitBtn.textContent = this.submitBtn.dataset.labelAdding;
      if (this.formMessage) this.formMessage.textContent = '';

      try {
        const response = await fetch(this.form.action, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(this.form)
        });
        const data = await response.json();
        if (!response.ok) {
          throw new Error(data.description || data.message || 'add_to_cart_failed');
        }

        const cartResponse = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
        const cart = await cartResponse.json();
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { itemCount: cart.item_count } }));

        this.submitBtn.textContent = this.submitBtn.dataset.labelAdded;
        if (this.formMessage) this.formMessage.textContent = this.submitBtn.dataset.labelAdded;
      } catch (error) {
        this.submitBtn.textContent = this.submitBtn.dataset.labelError;
        if (this.formMessage) this.formMessage.textContent = this.submitBtn.dataset.labelError;
      } finally {
        setTimeout(() => {
          this.submitBtn.textContent = originalLabel;
          this.submitBtn.disabled = false;
          if (this.formMessage) this.formMessage.textContent = '';
        }, 1800);
      }
    }
  }

  customElements.define('product-quick-shop', ProductQuickShop);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-closing-ala"]) return;
  try {
    
  class LpClosingAla extends HTMLElement {
    connectedCallback() {
      this.querySelectorAll('[data-lp-scroll-to]').forEach((link) => {
        link.addEventListener('click', (event) => {
          const target = document.querySelector(link.dataset.lpScrollTo);
          if (!target) return;
          event.preventDefault();
          const offset = window.innerWidth <= 767 ? 50 : 70;
          window.scrollTo({
            top: target.getBoundingClientRect().top + window.scrollY - offset,
            behavior: 'smooth'
          });
        });
      });
    }
  }

  customElements.define('lp-closing-ala', LpClosingAla);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-faq"]) return;
  try {
    
  class LpFaqAccordion extends HTMLElement {
    connectedCallback() {
      const items = Array.from(this.querySelectorAll('[data-lp-faq-row]'));
      items.forEach((item) => {
        const heading = item.querySelector('[data-lp-faq-row-heading]');
        const content = item.querySelector('[data-lp-faq-row-content]');
        if (!heading || !content) return;

        heading.addEventListener('click', () => {
          const isOpen = heading.classList.contains('lp-faq-item__heading--open');

          items.forEach((other) => {
            if (other === item) return;
            const otherHeading = other.querySelector('[data-lp-faq-row-heading]');
            const otherContent = other.querySelector('[data-lp-faq-row-content]');
            if (otherHeading) otherHeading.classList.remove('lp-faq-item__heading--open');
            if (otherContent) otherContent.style.display = 'none';
          });

          heading.classList.toggle('lp-faq-item__heading--open', !isOpen);
          content.style.display = isOpen ? 'none' : '';
        });
      });
    }
  }

  customElements.define('lp-faq-accordion', LpFaqAccordion);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-header"]) return;
  try {
    
  class LpHeader extends HTMLElement {
    connectedCallback() {
      // See lp-hero-v1.liquid for why these run in isolation rather than
      // as plain sequential calls.
      [
        'initSticky',
        'initScrollLinks',
        'startCountdown',
        'initCartCount'
      ].forEach((method) => {
        try {
          this[method]();
        } catch (error) {
          console.error(`lp-header: ${method} failed`, error);
        }
      });
    }

    initCartCount() {
      // Same event the sitewide header.liquid listens for — every
      // add-to-cart on this page (and any other page) dispatches it.
      document.addEventListener('cart:updated', (event) => {
        const count = this.querySelector('[data-lp-cart-count]');
        if (!count || !event.detail || typeof event.detail.itemCount !== 'number') return;
        count.textContent = String(event.detail.itemCount);
      });
    }

    initSticky() {
      this.bar = this.querySelector('[data-lp-header-bar]');
      window.addEventListener('scroll', () => this.handleScroll(), { passive: true });
      this.handleScroll();
    }

    initScrollLinks() {
      this.querySelectorAll('[data-lp-scroll-to]').forEach((link) => {
        link.addEventListener('click', (event) => {
          const target = document.querySelector(link.dataset.lpScrollTo);
          if (!target) return;
          event.preventDefault();
          const offset = window.innerWidth <= 767 ? 50 : 80;
          window.scrollTo({
            top: target.getBoundingClientRect().top + window.scrollY - offset,
            behavior: 'smooth'
          });
        });
      });
    }

    handleScroll() {
      this.classList.toggle('lp-header--fixed', window.scrollY > 40);
    }

    startCountdown() {
      const timer = this.querySelector('[data-lp-countdown]');
      if (!timer) return;

      const hoursEl = timer.querySelector('[data-lp-hours]');
      const minutesEl = timer.querySelector('[data-lp-minutes]');
      const secondsEl = timer.querySelector('[data-lp-seconds]');
      let totalSeconds = (parseInt(timer.dataset.minutes, 10) || 53) * 60;

      const update = () => {
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;
        if (hoursEl) hoursEl.textContent = String(hours).padStart(2, '0');
        if (minutesEl) minutesEl.textContent = String(minutes).padStart(2, '0');
        if (secondsEl) secondsEl.textContent = String(seconds).padStart(2, '0');
        if (totalSeconds <= 0) {
          clearInterval(interval);
          return;
        }
        totalSeconds--;
      };

      update();
      const interval = setInterval(update, 1000);
    }
  }

  customElements.define('lp-header', LpHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-hero-ala-angle"]) return;
  try {
    
  class LpHeroAlaBuybox extends HTMLElement {
    connectedCallback() {
      const slides = Array.from(this.querySelectorAll('[data-lp-gallery-slide]'));
      const thumbs = Array.from(this.querySelectorAll('[data-lp-gallery-thumb]'));
      const prevBtn = this.querySelector('[data-lp-gallery-prev]');
      const nextBtn = this.querySelector('[data-lp-gallery-next]');
      let currentSlide = 0;

      const setSlide = (index) => {
        if (!slides.length) return;
        currentSlide = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => slide.classList.toggle('lp-hero-abb__slide--active', i === currentSlide));
        thumbs.forEach((thumb, i) => thumb.classList.toggle('lp-hero-abb__thumb--active', i === currentSlide));
      };

      thumbs.forEach((thumb, i) => {
        thumb.addEventListener('click', () => setSlide(i));
      });

      if (prevBtn) prevBtn.addEventListener('click', () => setSlide(currentSlide - 1));
      if (nextBtn) nextBtn.addEventListener('click', () => setSlide(currentSlide + 1));

      this.querySelectorAll('[data-lp-faq-toggle]').forEach((button) => {
        button.addEventListener('click', () => {
          const item = button.closest('[data-lp-faq-item]');
          if (item) item.classList.toggle('lp-hero-abb__faq-item--active');
        });
      });

      const form = this.querySelector('[data-lp-cart-form]');
      const addButton = this.querySelector('[data-lp-add-to-cart]');
      const message = this.querySelector('[data-lp-form-message]');
      if (form && addButton) {
        form.addEventListener('submit', (event) => {
          if (addButton.disabled) return;
          const kachingInput = form.querySelector('[name="id"]');
          if (kachingInput) return;
          event.preventDefault();
          if (message) message.textContent = 'Select a package above to continue.';
        });
      }
    }
  }

  if (!customElements.get('lp-hero-ala-buybox')) customElements.define('lp-hero-ala-buybox', LpHeroAlaBuybox);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-hero-ala-buybox-v1"]) return;
  try {
    
  class LpHeroAlaBuybox extends HTMLElement {
    connectedCallback() {
      const slides = Array.from(this.querySelectorAll('[data-lp-gallery-slide]'));
      const thumbs = Array.from(this.querySelectorAll('[data-lp-gallery-thumb]'));
      const prevBtn = this.querySelector('[data-lp-gallery-prev]');
      const nextBtn = this.querySelector('[data-lp-gallery-next]');
      let currentSlide = 0;

      const setSlide = (index) => {
        if (!slides.length) return;
        currentSlide = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => slide.classList.toggle('lp-hero-abb__slide--active', i === currentSlide));
        thumbs.forEach((thumb, i) => thumb.classList.toggle('lp-hero-abb__thumb--active', i === currentSlide));
      };

      thumbs.forEach((thumb, i) => {
        thumb.addEventListener('click', () => setSlide(i));
      });

      if (prevBtn) prevBtn.addEventListener('click', () => setSlide(currentSlide - 1));
      if (nextBtn) nextBtn.addEventListener('click', () => setSlide(currentSlide + 1));

      this.querySelectorAll('[data-lp-faq-toggle]').forEach((button) => {
        button.addEventListener('click', () => {
          const item = button.closest('[data-lp-faq-item]');
          if (item) item.classList.toggle('lp-hero-abb__faq-item--active');
        });
      });

      const form = this.querySelector('[data-lp-cart-form]');
      const addButton = this.querySelector('[data-lp-add-to-cart]');
      const message = this.querySelector('[data-lp-form-message]');
      if (form && addButton) {
        form.addEventListener('submit', (event) => {
          if (addButton.disabled) return;
          const kachingInput = form.querySelector('[name="id"]');
          if (kachingInput) return;
          event.preventDefault();
          if (message) message.textContent = 'Select a package above to continue.';
        });
      }
    }
  }

  customElements.define('lp-hero-ala-buybox', LpHeroAlaBuybox);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-hero-ala-buybox-v2"]) return;
  try {
    
  class LpHeroAlaBuybox extends HTMLElement {
    connectedCallback() {
      const slides = Array.from(this.querySelectorAll('[data-lp-gallery-slide]'));
      const thumbs = Array.from(this.querySelectorAll('[data-lp-gallery-thumb]'));
      const prevBtn = this.querySelector('[data-lp-gallery-prev]');
      const nextBtn = this.querySelector('[data-lp-gallery-next]');
      let currentSlide = 0;

      const setSlide = (index) => {
        if (!slides.length) return;
        currentSlide = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => slide.classList.toggle('lp-hero-abb__slide--active', i === currentSlide));
        thumbs.forEach((thumb, i) => thumb.classList.toggle('lp-hero-abb__thumb--active', i === currentSlide));
      };

      thumbs.forEach((thumb, i) => {
        thumb.addEventListener('click', () => setSlide(i));
      });

      if (prevBtn) prevBtn.addEventListener('click', () => setSlide(currentSlide - 1));
      if (nextBtn) nextBtn.addEventListener('click', () => setSlide(currentSlide + 1));

      this.querySelectorAll('[data-lp-faq-toggle]').forEach((button) => {
        button.addEventListener('click', () => {
          const item = button.closest('[data-lp-faq-item]');
          if (item) item.classList.toggle('lp-hero-abb__faq-item--active');
        });
      });

      const form = this.querySelector('[data-lp-cart-form]');
      const addButton = this.querySelector('[data-lp-add-to-cart]');
      const message = this.querySelector('[data-lp-form-message]');
      if (form && addButton) {
        form.addEventListener('submit', (event) => {
          if (addButton.disabled) return;
          const kachingInput = form.querySelector('[name="id"]');
          if (kachingInput) return;
          event.preventDefault();
          if (message) message.textContent = 'Select a package above to continue.';
        });
      }
    }
  }

  customElements.define('lp-hero-ala-buybox', LpHeroAlaBuybox);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-hero-ala-buybox-v3"]) return;
  try {
    
  class LpHeroAlaBuybox extends HTMLElement {
    connectedCallback() {
      const slides = Array.from(this.querySelectorAll('[data-lp-gallery-slide]'));
      const thumbs = Array.from(this.querySelectorAll('[data-lp-gallery-thumb]'));
      const prevBtn = this.querySelector('[data-lp-gallery-prev]');
      const nextBtn = this.querySelector('[data-lp-gallery-next]');
      let currentSlide = 0;

      const setSlide = (index) => {
        if (!slides.length) return;
        currentSlide = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => slide.classList.toggle('lp-hero-abb__slide--active', i === currentSlide));
        thumbs.forEach((thumb, i) => thumb.classList.toggle('lp-hero-abb__thumb--active', i === currentSlide));
      };

      thumbs.forEach((thumb, i) => {
        thumb.addEventListener('click', () => setSlide(i));
      });

      if (prevBtn) prevBtn.addEventListener('click', () => setSlide(currentSlide - 1));
      if (nextBtn) nextBtn.addEventListener('click', () => setSlide(currentSlide + 1));

      this.querySelectorAll('[data-lp-faq-toggle]').forEach((button) => {
        button.addEventListener('click', () => {
          const item = button.closest('[data-lp-faq-item]');
          if (item) item.classList.toggle('lp-hero-abb__faq-item--active');
        });
      });

      const form = this.querySelector('[data-lp-cart-form]');
      const addButton = this.querySelector('[data-lp-add-to-cart]');
      const message = this.querySelector('[data-lp-form-message]');
      if (form && addButton) {
        form.addEventListener('submit', (event) => {
          if (addButton.disabled) return;
          const kachingInput = form.querySelector('[name="id"]');
          if (kachingInput) return;
          event.preventDefault();
          if (message) message.textContent = 'Select a package above to continue.';
        });
      }
    }
  }

  customElements.define('lp-hero-ala-buybox', LpHeroAlaBuybox);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-hero-ala-buybox-v4"]) return;
  try {
    
  class LpHeroAlaBuybox extends HTMLElement {
    connectedCallback() {
      const slides = Array.from(this.querySelectorAll('[data-lp-gallery-slide]'));
      const thumbs = Array.from(this.querySelectorAll('[data-lp-gallery-thumb]'));
      const prevBtn = this.querySelector('[data-lp-gallery-prev]');
      const nextBtn = this.querySelector('[data-lp-gallery-next]');
      let currentSlide = 0;

      const setSlide = (index) => {
        if (!slides.length) return;
        currentSlide = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => slide.classList.toggle('lp-hero-abb__slide--active', i === currentSlide));
        thumbs.forEach((thumb, i) => thumb.classList.toggle('lp-hero-abb__thumb--active', i === currentSlide));
      };

      thumbs.forEach((thumb, i) => {
        thumb.addEventListener('click', () => setSlide(i));
      });

      if (prevBtn) prevBtn.addEventListener('click', () => setSlide(currentSlide - 1));
      if (nextBtn) nextBtn.addEventListener('click', () => setSlide(currentSlide + 1));

      this.querySelectorAll('[data-lp-faq-toggle]').forEach((button) => {
        button.addEventListener('click', () => {
          const item = button.closest('[data-lp-faq-item]');
          if (item) item.classList.toggle('lp-hero-abb__faq-item--active');
        });
      });

      const form = this.querySelector('[data-lp-cart-form]');
      const addButton = this.querySelector('[data-lp-add-to-cart]');
      const message = this.querySelector('[data-lp-form-message]');
      if (form && addButton) {
        form.addEventListener('submit', (event) => {
          if (addButton.disabled) return;
          const kachingInput = form.querySelector('[name="id"]');
          if (kachingInput) return;
          event.preventDefault();
          if (message) message.textContent = 'Select a package above to continue.';
        });
      }
    }
  }

  customElements.define('lp-hero-ala-buybox', LpHeroAlaBuybox);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-hero-ala-buybox-v5"]) return;
  try {
    
  class LpHeroAlaBuybox extends HTMLElement {
    connectedCallback() {
      const slides = Array.from(this.querySelectorAll('[data-lp-gallery-slide]'));
      const thumbs = Array.from(this.querySelectorAll('[data-lp-gallery-thumb]'));
      const prevBtn = this.querySelector('[data-lp-gallery-prev]');
      const nextBtn = this.querySelector('[data-lp-gallery-next]');
      let currentSlide = 0;

      const setSlide = (index) => {
        if (!slides.length) return;
        currentSlide = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => slide.classList.toggle('lp-hero-abb__slide--active', i === currentSlide));
        thumbs.forEach((thumb, i) => thumb.classList.toggle('lp-hero-abb__thumb--active', i === currentSlide));
      };

      thumbs.forEach((thumb, i) => {
        thumb.addEventListener('click', () => setSlide(i));
      });

      if (prevBtn) prevBtn.addEventListener('click', () => setSlide(currentSlide - 1));
      if (nextBtn) nextBtn.addEventListener('click', () => setSlide(currentSlide + 1));

      this.querySelectorAll('[data-lp-faq-toggle]').forEach((button) => {
        button.addEventListener('click', () => {
          const item = button.closest('[data-lp-faq-item]');
          if (item) item.classList.toggle('lp-hero-abb__faq-item--active');
        });
      });

      const form = this.querySelector('[data-lp-cart-form]');
      const addButton = this.querySelector('[data-lp-add-to-cart]');
      const message = this.querySelector('[data-lp-form-message]');
      if (form && addButton) {
        form.addEventListener('submit', (event) => {
          if (addButton.disabled) return;
          const kachingInput = form.querySelector('[name="id"]');
          if (kachingInput) return;
          event.preventDefault();
          if (message) message.textContent = 'Select a package above to continue.';
        });
      }
    }
  }

  customElements.define('lp-hero-ala-buybox', LpHeroAlaBuybox);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-hero-ala-buybox-v6"]) return;
  try {
    
  class LpHeroAlaBuybox extends HTMLElement {
    connectedCallback() {
      const slides = Array.from(this.querySelectorAll('[data-lp-gallery-slide]'));
      const thumbs = Array.from(this.querySelectorAll('[data-lp-gallery-thumb]'));
      const prevBtn = this.querySelector('[data-lp-gallery-prev]');
      const nextBtn = this.querySelector('[data-lp-gallery-next]');
      let currentSlide = 0;

      const setSlide = (index) => {
        if (!slides.length) return;
        currentSlide = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => slide.classList.toggle('lp-hero-abb__slide--active', i === currentSlide));
        thumbs.forEach((thumb, i) => thumb.classList.toggle('lp-hero-abb__thumb--active', i === currentSlide));
      };

      thumbs.forEach((thumb, i) => {
        thumb.addEventListener('click', () => setSlide(i));
      });

      if (prevBtn) prevBtn.addEventListener('click', () => setSlide(currentSlide - 1));
      if (nextBtn) nextBtn.addEventListener('click', () => setSlide(currentSlide + 1));

      this.querySelectorAll('[data-lp-faq-toggle]').forEach((button) => {
        button.addEventListener('click', () => {
          const item = button.closest('[data-lp-faq-item]');
          if (item) item.classList.toggle('lp-hero-abb__faq-item--active');
        });
      });

      const form = this.querySelector('[data-lp-cart-form]');
      const addButton = this.querySelector('[data-lp-add-to-cart]');
      const message = this.querySelector('[data-lp-form-message]');
      if (form && addButton) {
        form.addEventListener('submit', (event) => {
          if (addButton.disabled) return;
          const kachingInput = form.querySelector('[name="id"]');
          if (kachingInput) return;
          event.preventDefault();
          if (message) message.textContent = 'Select a package above to continue.';
        });
      }
    }
  }

  customElements.define('lp-hero-ala-buybox', LpHeroAlaBuybox);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-hero-ala-buybox"]) return;
  try {
    
  class LpHeroAlaBuybox extends HTMLElement {
    connectedCallback() {
      const slides = Array.from(this.querySelectorAll('[data-lp-gallery-slide]'));
      const thumbs = Array.from(this.querySelectorAll('[data-lp-gallery-thumb]'));
      const prevBtn = this.querySelector('[data-lp-gallery-prev]');
      const nextBtn = this.querySelector('[data-lp-gallery-next]');
      let currentSlide = 0;

      const setSlide = (index) => {
        if (!slides.length) return;
        currentSlide = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => slide.classList.toggle('lp-hero-abb__slide--active', i === currentSlide));
        thumbs.forEach((thumb, i) => thumb.classList.toggle('lp-hero-abb__thumb--active', i === currentSlide));
      };

      thumbs.forEach((thumb, i) => {
        thumb.addEventListener('click', () => setSlide(i));
      });

      if (prevBtn) prevBtn.addEventListener('click', () => setSlide(currentSlide - 1));
      if (nextBtn) nextBtn.addEventListener('click', () => setSlide(currentSlide + 1));

      this.querySelectorAll('[data-lp-faq-toggle]').forEach((button) => {
        button.addEventListener('click', () => {
          const item = button.closest('[data-lp-faq-item]');
          if (item) item.classList.toggle('lp-hero-abb__faq-item--active');
        });
      });

      const form = this.querySelector('[data-lp-cart-form]');
      const addButton = this.querySelector('[data-lp-add-to-cart]');
      const message = this.querySelector('[data-lp-form-message]');
      if (form && addButton) {
        form.addEventListener('submit', (event) => {
          if (addButton.disabled) return;
          const kachingInput = form.querySelector('[name="id"]');
          if (kachingInput) return;
          event.preventDefault();
          if (message) message.textContent = 'Select a package above to continue.';
        });
      }
    }
  }

  customElements.define('lp-hero-ala-buybox', LpHeroAlaBuybox);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-hero-ala"]) return;
  try {
    
  class LpHeroAla extends HTMLElement {
    connectedCallback() {
      this.querySelectorAll('[data-lp-scroll-to]').forEach((link) => {
        link.addEventListener('click', (event) => {
          const target = document.querySelector(link.dataset.lpScrollTo);
          if (!target) return;
          event.preventDefault();
          const offset = window.innerWidth <= 767 ? 50 : 70;
          window.scrollTo({
            top: target.getBoundingClientRect().top + window.scrollY - offset,
            behavior: 'smooth'
          });
        });
      });
    }
  }

  customElements.define('lp-hero-ala', LpHeroAla);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-hero-v1"]) return;
  try {
    
  class LpHeroV1 extends HTMLElement {
    connectedCallback() {
      // Each init runs in isolation — one throwing must never silently
      // stop the rest from wiring up (the earlier version chained these
      // as plain calls, so a single exception anywhere upstream could
      // have taken out every interaction after it).
      [
        'initGallery',
        'initFaq',
        'initAddons',
        'initBuyBox',
        'initVideoTeaser',
        'initScrollLinks'
      ].forEach((method) => {
        try {
          this[method]();
        } catch (error) {
          console.error(`lp-hero-v1: ${method} failed`, error);
        }
      });
    }

    initScrollLinks() {
      this.querySelectorAll('[data-lp-scroll-to]').forEach((link) => {
        link.addEventListener('click', (event) => {
          const target = document.querySelector(link.dataset.lpScrollTo);
          if (!target) return;
          event.preventDefault();
          const offset = window.innerWidth <= 767 ? 50 : 70;
          window.scrollTo({
            top: target.getBoundingClientRect().top + window.scrollY - offset,
            behavior: 'smooth'
          });
        });
      });
    }

    initGallery() {
      const stage = this.querySelector('[data-lp-gallery-stage] img');
      const thumbs = Array.from(this.querySelectorAll('[data-lp-gallery-thumb]'));
      if (!stage || !thumbs.length) return;
      let index = 0;

      const setIndex = (newIndex) => {
        index = (newIndex + thumbs.length) % thumbs.length;
        const thumb = thumbs[index];
        // Defensive: a srcset (auto or otherwise) takes priority over src.
        // Clear it so the swap is never silently overridden.
        stage.removeAttribute('srcset');
        stage.removeAttribute('sizes');
        stage.src = thumb.dataset.full;
        thumbs.forEach((t, i) => t.classList.toggle('lp-hero__thumb--active', i === index));
        thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      };

      thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => setIndex(i)));

      const prev = this.querySelector('[data-lp-gallery-prev]');
      const next = this.querySelector('[data-lp-gallery-next]');
      if (prev) prev.addEventListener('click', () => setIndex(index - 1));
      if (next) next.addEventListener('click', () => setIndex(index + 1));

      // The lag was every full-size (1140px) image fetching fresh over the
      // network on first click — nothing was ever cached ahead of time.
      // Warm the browser cache for the other 9 in the background, off the
      // critical path, so by the time someone clicks, it's already local.
      const preload = () => {
        thumbs.forEach((thumb, i) => {
          if (i === 0) return; // already the visible stage image
          const img = new Image();
          img.src = thumb.dataset.full;
        });
      };
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(preload, { timeout: 2000 });
      } else {
        setTimeout(preload, 1000);
      }
    }

    initFaq() {
      const items = this.querySelectorAll('[data-lp-faq-item]');
      items.forEach((item) => {
        const toggle = item.querySelector('[data-lp-faq-toggle]');
        const answer = item.querySelector('[data-lp-faq-answer]');
        const icon = item.querySelector('[data-lp-faq-icon]');
        if (!toggle || !answer) return;

        toggle.addEventListener('click', () => {
          const isOpen = item.classList.contains('lp-hero__faq-item--active');

          items.forEach((other) => {
            if (other === item) return;
            other.classList.remove('lp-hero__faq-item--active');
            const otherAnswer = other.querySelector('[data-lp-faq-answer]');
            const otherIcon = other.querySelector('[data-lp-faq-icon]');
            if (otherAnswer) otherAnswer.style.display = 'none';
            if (otherIcon) otherIcon.textContent = '+';
          });

          if (isOpen) {
            item.classList.remove('lp-hero__faq-item--active');
            answer.style.display = 'none';
            if (icon) icon.textContent = '+';
          } else {
            item.classList.add('lp-hero__faq-item--active');
            answer.style.display = '';
            if (icon) icon.textContent = '−';
          }
        });
      });
    }

    initAddons() {
      // Each cross-sell "Add" button adds itself to the cart immediately
      // (same pattern as lp-package.liquid's independent buttons) rather
      // than just staging a selection for the main ADD TO CART click below
      // — that two-step design gave no feedback of its own, which read as
      // "doesn't do anything" even when the toggle itself was working.
      this.querySelectorAll('[data-lp-addon-toggle]').forEach((btn) => {
        const label = btn.querySelector('.lp-hero__addon-btn-text');
        const icon = btn.querySelector('.lp-hero__addon-btn-icon');

        btn.addEventListener('click', async () => {
          if (btn.disabled || btn.dataset.selected === 'true') return;
          btn.disabled = true;
          if (label) label.textContent = 'Adding…';

          try {
            const response = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: [{ id: btn.dataset.variantId, quantity: 1 }] })
            });
            const data = await response.json();
            if (!response.ok) {
              throw new Error(data.description || data.message || 'add_to_cart_failed');
            }

            const cartResponse = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
            const cart = await cartResponse.json();
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { itemCount: cart.item_count } }));

            btn.dataset.selected = 'true';
            if (label) label.textContent = 'Added';
            if (icon) icon.textContent = '✓';
          } catch (error) {
            btn.disabled = false;
            if (label) label.textContent = 'Add';
            if (icon) icon.textContent = '+';
          }
        });
      });
    }

    initBuyBox() {
      const buyBox = this.querySelector('[data-lp-buy-box]');
      const cartBtn = this.querySelector('[data-lp-add-to-cart]');
      const message = this.querySelector('[data-lp-form-message]');
      const btnLabel = this.querySelector('[data-lp-cart-btn-label]');
      if (!buyBox || !cartBtn) return;

      // The --selected highlight class is only baked in at render time
      // for whichever tier is the default — nothing was updating it on
      // click, so the other two tiers were selectable at the native
      // DOM level (a real add-to-cart would have used the right one)
      // but looked completely unresponsive, since the highlight never
      // moved. Sync it on every change.
      this.querySelectorAll('[data-lp-tier-input]').forEach((input) => {
        input.addEventListener('change', () => {
          this.querySelectorAll('[data-lp-tier-input]').forEach((other) => {
            other.closest('.lp-hero__quantity-option').classList.toggle('lp-hero__quantity-option--selected', other === input);
          });
        });
      });

      // The button is now type="submit" inside a real <form
      // action="/cart/add"> — required so Kaching Bundles' own script
      // (which hooks its click handling onto that native submit button,
      // per its docs) can find and control it. This fetch-based flow
      // only takes over when the legacy picker is the active pricing
      // mechanism; when it's toggled off (Kaching is live instead), skip
      // attaching this listener entirely so Kaching's own handling of
      // the submit isn't raced or double-added-to-cart by this one.
      if (cartBtn.dataset.legacyPricingActive !== 'true') return;

      cartBtn.addEventListener('click', async (event) => {
        // Stop the native form submission this button would now
        // otherwise trigger (a real POST/page navigation to
        // /cart/add) — this flow replaces it with its own fetch-based
        // add-to-cart below.
        event.preventDefault();

        const selectedTier = this.querySelector('[data-lp-tier-input]:checked');
        if (!selectedTier || !selectedTier.value) {
          if (message) message.textContent = 'Choose a package above';
          return;
        }

        const items = [{ id: selectedTier.value, quantity: 1 }];

        cartBtn.disabled = true;
        if (btnLabel) btnLabel.textContent = cartBtn.dataset.labelAdding;
        if (message) message.textContent = '';

        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items })
          });
          const data = await response.json();
          if (!response.ok) {
            throw new Error(data.description || data.message || 'add_to_cart_failed');
          }

          const cartResponse = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
          const cart = await cartResponse.json();
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { itemCount: cart.item_count } }));

          if (btnLabel) btnLabel.textContent = cartBtn.dataset.labelAdded;
          if (message) {
            message.innerHTML = '';
            message.append(document.createTextNode('Added to cart — '));
            const viewCartLink = document.createElement('a');
            viewCartLink.href = message.dataset.cartUrl;
            viewCartLink.className = 'lp-hero__form-message-link';
            viewCartLink.textContent = 'View cart';
            message.append(viewCartLink);
          }
        } catch (error) {
          if (btnLabel) btnLabel.textContent = cartBtn.dataset.labelError;
          if (message) message.textContent = cartBtn.dataset.labelError;
        } finally {
          setTimeout(() => {
            cartBtn.disabled = false;
            if (btnLabel) btnLabel.textContent = cartBtn.dataset.labelDefault;
            if (message) message.textContent = '';
          }, 2200);
        }
      });
    }

    initVideoTeaser() {
      const modal = this.querySelector('[data-lp-video-modal]');
      const player = this.querySelector('[data-lp-video-player]');
      const closeBtn = this.querySelector('[data-lp-video-close]');
      if (!modal || !player) return;

      const openModal = (src) => {
        player.src = src;
        player.play();
        modal.classList.add('lp-hero__video-modal--active');
      };

      const closeModal = () => {
        player.pause();
        player.src = '';
        modal.classList.remove('lp-hero__video-modal--active');
      };

      this.querySelectorAll('[data-lp-video-trigger]').forEach((trigger) => {
        trigger.addEventListener('click', () => openModal(trigger.dataset.videoSrc));
      });

      if (closeBtn) closeBtn.addEventListener('click', closeModal);
      modal.addEventListener('click', (event) => {
        if (event.target === modal) closeModal();
      });
    }
  }

  customElements.define('lp-hero-v1', LpHeroV1);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-hero-v2"]) return;
  try {
    
  class LpHeroV2 extends HTMLElement {
    connectedCallback() {
      this.querySelectorAll('[data-lp-scroll-to]').forEach((link) => {
        link.addEventListener('click', (event) => {
          const target = document.querySelector(link.dataset.lpScrollTo);
          if (!target) return;
          event.preventDefault();
          const offset = window.innerWidth <= 767 ? 50 : 70;
          window.scrollTo({
            top: target.getBoundingClientRect().top + window.scrollY - offset,
            behavior: 'smooth'
          });
        });
      });
    }
  }

  customElements.define('lp-hero-v2', LpHeroV2);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-ingredients"]) return;
  try {
    
  class LpIngredients extends HTMLElement {
    connectedCallback() {
      const accordion = this.querySelector('[data-lp-ingredients-accordion]');
      if (!accordion) return;
      const items = Array.from(accordion.querySelectorAll('[data-lp-ingredient-item]'));

      items.forEach((item) => {
        const question = item.querySelector('[data-lp-ingredient-question]');
        const answer = item.querySelector('[data-lp-ingredient-answer]');
        const icon = item.querySelector('[data-lp-ingredient-icon]');
        if (!question || !answer) return;

        question.addEventListener('click', () => {
          // Matches the source design exactly: clicking an already-open
          // item keeps it open (no toggle-close), unlike the FAQ
          // accordion elsewhere in this theme.
          if (item.classList.contains('lp-ingredient-item--active')) return;

          items.forEach((other) => {
            other.classList.remove('lp-ingredient-item--active');
            const otherAnswer = other.querySelector('[data-lp-ingredient-answer]');
            const otherIcon = other.querySelector('[data-lp-ingredient-icon]');
            if (otherAnswer) otherAnswer.style.display = 'none';
            if (otherIcon) otherIcon.textContent = '+';
          });

          item.classList.add('lp-ingredient-item--active');
          answer.style.display = 'block';
          if (icon) icon.textContent = '−';
        });
      });
    }
  }

  customElements.define('lp-ingredients', LpIngredients);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-package-ala"]) return;
  try {
    
  class LpPackageAla extends HTMLElement {
    connectedCallback() {
      this.message = this.querySelector('[data-lp-package-message]');
    }
  }

  customElements.define('lp-package-ala', LpPackageAla);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-package"]) return;
  try {
    
  class LpPackage extends HTMLElement {
    connectedCallback() {
      this.message = this.querySelector('[data-lp-package-message]');
      this.querySelectorAll('[data-lp-package-add]').forEach((btn) => {
        btn.addEventListener('click', () => this.addToCart(btn));
      });
      this.startCountdown();
    }

    startCountdown() {
      // Matches the source design exactly: a genuine 6-hour countdown
      // from page load (the source's own inline comment says "3 hours
      // 55 minutes", but its actual code counts down from 6 * 60 * 60 —
      // replicating the real behavior, not the stale comment).
      const el = this.querySelector('[data-lp-package-countdown]');
      if (!el) return;
      let totalSeconds = 6 * 60 * 60;

      const update = () => {
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;
        el.textContent = [hours, minutes, seconds].map((n) => String(n).padStart(2, '0')).join(':');
        if (totalSeconds <= 0) {
          clearInterval(interval);
          return;
        }
        totalSeconds--;
      };

      update();
      const interval = setInterval(update, 1000);
    }

    async addToCart(btn) {
      if (btn.disabled) return;
      const variantId = btn.dataset.variantId;
      btn.disabled = true;
      btn.textContent = btn.dataset.labelAdding;
      if (this.message) this.message.textContent = '';

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        });
        const data = await response.json();
        if (!response.ok) {
          throw new Error(data.description || data.message || 'add_to_cart_failed');
        }

        const cartResponse = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
        const cart = await cartResponse.json();
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { itemCount: cart.item_count } }));

        btn.textContent = btn.dataset.labelAdded;
        if (this.message) {
          this.message.innerHTML = '';
          this.message.append(document.createTextNode('Added to cart — '));
          const viewCartLink = document.createElement('a');
          viewCartLink.href = this.message.dataset.cartUrl;
          viewCartLink.className = 'lp-package__form-message-link';
          viewCartLink.textContent = 'View cart';
          this.message.append(viewCartLink);
        }
      } catch (error) {
        btn.textContent = btn.dataset.labelError;
        if (this.message) this.message.textContent = 'Couldn’t add — try again';
      } finally {
        setTimeout(() => {
          btn.disabled = false;
          btn.textContent = btn.dataset.labelDefault;
          if (this.message) this.message.textContent = '';
        }, 2200);
      }
    }
  }

  customElements.define('lp-package', LpPackage);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-result"]) return;
  try {
    
  class LpResult extends HTMLElement {
    connectedCallback() {
      this.content = this.querySelector('[data-lp-result-content]');
      this.drawLine = this.querySelector('[data-lp-result-draw-line]');
      if (!this.content || !this.drawLine) return;

      this.onScroll = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.onScroll();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
    }

    onScroll() {
      const timelineDistance = this.content.getBoundingClientRect().top + window.scrollY;
      const windowDistance = window.scrollY;
      const windowHeight = window.innerHeight / 2;
      const greyLineHeight = this.querySelector('.lp-result__default-line').offsetHeight;

      if (windowDistance >= timelineDistance - windowHeight) {
        const line = windowDistance - timelineDistance + windowHeight;
        if (line <= greyLineHeight) {
          this.drawLine.style.height = line + 'px';
        }
      }
    }
  }

  customElements.define('lp-result', LpResult);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ls-buybox"] && !Shopify.designMode) return;
  try {
    
  class LsBuybox extends HTMLElement {
    connectedCallback() {
      this.initGallery();
      this.initForm();
    }

    initGallery() {
      const slides = Array.from(this.querySelectorAll('[data-ls-slide]'));
      const thumbs = Array.from(this.querySelectorAll('[data-ls-thumb]'));
      if (slides.length < 2) return;
      let current = 0;

      const show = (index) => {
        current = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => slide.classList.toggle('ls-buybox__slide--active', i === current));
        thumbs.forEach((thumb, i) => thumb.classList.toggle('ls-buybox__thumb--active', i === current));
      };

      thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => show(i)));
      const prev = this.querySelector('[data-ls-prev]');
      const next = this.querySelector('[data-ls-next]');
      if (prev) prev.addEventListener('click', () => show(current - 1));
      if (next) next.addEventListener('click', () => show(current + 1));
    }

    initForm() {
      this.form = this.querySelector('[data-ls-form]');
      if (!this.form || !this.form.matches('form')) return;
      this.submitBtn = this.form.querySelector('[data-ls-submit]');
      this.message = this.form.querySelector('[data-ls-message]');

      this.kachingLive = false;
      if (this.form.dataset.lsMode === 'kaching') this.watchForKaching();

      this.qtyInput = this.form.querySelector('[data-ls-qty-input]');
      this.form.querySelectorAll('[data-ls-qty]').forEach((button) => {
        button.addEventListener('click', () => {
          if (!this.qtyInput) return;
          const next = (parseInt(this.qtyInput.value, 10) || 1) + parseInt(button.dataset.lsQty, 10);
          this.qtyInput.value = Math.min(20, Math.max(1, next));
        });
      });

      this.form.addEventListener('submit', (event) => {
        if (this.kachingLive) {
          if (this.form.querySelector('[name="id"]:not(:disabled)')) return;
          event.preventDefault();
          if (this.message) this.message.textContent = this.message.dataset.selectText || '';
          return;
        }
        this.handleSubmit(event);
      });
    }

    watchForKaching() {
      const container = this.form.querySelector('[data-ls-kaching]');
      if (!container) return;

      const activate = () => {
        if (this.kachingLive || !container.querySelector('.kaching-bundles')) return false;
        this.kachingLive = true;
        this.form.querySelectorAll('[data-ls-own]').forEach((element) => {
          element.hidden = true;
          element.querySelectorAll('input').forEach((input) => { input.disabled = true; });
          if (element.matches('input')) element.disabled = true;
        });
        return true;
      };

      if (activate()) return;
      const observer = new MutationObserver(() => {
        if (activate()) observer.disconnect();
      });
      observer.observe(container, { childList: true, subtree: true });
    }

    async handleSubmit(event) {
      event.preventDefault();
      if (!this.submitBtn || this.submitBtn.disabled) return;

      const labels = this.submitBtn.dataset;
      this.submitBtn.disabled = true;
      this.submitBtn.textContent = labels.labelAdding;
      if (this.message) this.message.textContent = '';

      try {
        const response = await fetch(this.form.action, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(this.form)
        });
        const data = await response.json();
        if (!response.ok) {
          throw new Error(data.description || data.message || 'add_to_cart_failed');
        }

        const cartResponse = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
        const cart = await cartResponse.json();
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { itemCount: cart.item_count } }));

        this.submitBtn.textContent = labels.labelAdded;
        if (this.message) this.message.textContent = labels.labelAdded;
      } catch (error) {
        this.submitBtn.textContent = labels.labelError;
        if (this.message) this.message.textContent = labels.labelError;
      } finally {
        setTimeout(() => {
          this.submitBtn.textContent = labels.label;
          this.submitBtn.disabled = false;
          if (this.message) this.message.textContent = '';
        }, 1800);
      }
    }
  }

  if (!customElements.get('ls-buybox')) customElements.define('ls-buybox', LsBuybox);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ls-hero-buybox"] && !Shopify.designMode) return;
  try {
    
  class LsHeroBuybox extends HTMLElement {
    connectedCallback() {
      this.initGallery();
      this.initForm();
    }

    initGallery() {
      const slides = Array.from(this.querySelectorAll('[data-ls-slide]'));
      const thumbs = Array.from(this.querySelectorAll('[data-ls-thumb]'));
      if (slides.length < 2) return;
      let current = 0;

      const show = (index) => {
        current = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => slide.classList.toggle('ls-hero-buybox__slide--active', i === current));
        thumbs.forEach((thumb, i) => thumb.classList.toggle('ls-hero-buybox__thumb--active', i === current));
      };

      thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => show(i)));
      const prev = this.querySelector('[data-ls-prev]');
      const next = this.querySelector('[data-ls-next]');
      if (prev) prev.addEventListener('click', () => show(current - 1));
      if (next) next.addEventListener('click', () => show(current + 1));
    }

    initForm() {
      this.form = this.querySelector('[data-ls-form]');
      if (!this.form || !this.form.matches('form')) return;
      this.submitBtn = this.form.querySelector('[data-ls-submit]');
      this.message = this.form.querySelector('[data-ls-message]');

      this.kachingLive = false;
      if (this.form.dataset.lsMode === 'kaching') this.watchForKaching();

      this.qtyInput = this.form.querySelector('[data-ls-qty-input]');
      this.form.querySelectorAll('[data-ls-qty]').forEach((button) => {
        button.addEventListener('click', () => {
          if (!this.qtyInput) return;
          const next = (parseInt(this.qtyInput.value, 10) || 1) + parseInt(button.dataset.lsQty, 10);
          this.qtyInput.value = Math.min(20, Math.max(1, next));
        });
      });

      this.form.addEventListener('submit', (event) => {
        if (this.kachingLive) {
          if (this.form.querySelector('[name="id"]:not(:disabled)')) return;
          event.preventDefault();
          if (this.message) this.message.textContent = this.message.dataset.selectText || '';
          return;
        }
        this.handleSubmit(event);
      });
    }

    watchForKaching() {
      const container = this.form.querySelector('[data-ls-kaching]');
      if (!container) return;

      const activate = () => {
        if (this.kachingLive || !container.querySelector('.kaching-bundles')) return false;
        this.kachingLive = true;
        this.form.querySelectorAll('[data-ls-own]').forEach((element) => {
          element.hidden = true;
          element.querySelectorAll('input').forEach((input) => { input.disabled = true; });
          if (element.matches('input')) element.disabled = true;
        });
        return true;
      };

      if (activate()) return;
      const observer = new MutationObserver(() => {
        if (activate()) observer.disconnect();
      });
      observer.observe(container, { childList: true, subtree: true });
    }

    async handleSubmit(event) {
      event.preventDefault();
      if (!this.submitBtn || this.submitBtn.disabled) return;

      const labels = this.submitBtn.dataset;
      this.submitBtn.disabled = true;
      this.submitBtn.textContent = labels.labelAdding;
      if (this.message) this.message.textContent = '';

      try {
        const response = await fetch(this.form.action, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(this.form)
        });
        const data = await response.json();
        if (!response.ok) {
          throw new Error(data.description || data.message || 'add_to_cart_failed');
        }

        const cartResponse = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
        const cart = await cartResponse.json();
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { itemCount: cart.item_count } }));

        this.submitBtn.textContent = labels.labelAdded;
        if (this.message) this.message.textContent = labels.labelAdded;
      } catch (error) {
        this.submitBtn.textContent = labels.labelError;
        if (this.message) this.message.textContent = labels.labelError;
      } finally {
        setTimeout(() => {
          this.submitBtn.textContent = labels.label;
          this.submitBtn.disabled = false;
          if (this.message) this.message.textContent = '';
        }, 1800);
      }
    }
  }

  if (!customElements.get('ls-hero-buybox')) customElements.define('ls-hero-buybox', LsHeroBuybox);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["plp-closing"]) return;
  try {
    
  class PlpClosing extends HTMLElement {
    connectedCallback() {
      this.querySelectorAll('[data-plp-scroll-to]').forEach((link) => {
        link.addEventListener('click', (event) => {
          const target = document.querySelector(link.dataset.plpScrollTo);
          if (!target) return;
          event.preventDefault();
          const offset = window.innerWidth <= 767 ? 50 : 70;
          window.scrollTo({
            top: target.getBoundingClientRect().top + window.scrollY - offset,
            behavior: 'smooth'
          });
        });
      });
    }
  }

  customElements.define('plp-closing', PlpClosing);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["plp-faq"]) return;
  try {
    
  class PlpFaqAccordion extends HTMLElement {
    connectedCallback() {
      const items = Array.from(this.querySelectorAll('[data-plp-faq-row]'));
      items.forEach((item) => {
        const heading = item.querySelector('[data-plp-faq-row-heading]');
        const content = item.querySelector('[data-plp-faq-row-content]');
        if (!heading || !content) return;

        heading.addEventListener('click', () => {
          const isOpen = heading.classList.contains('plp-faq-item__heading--open');

          items.forEach((other) => {
            if (other === item) return;
            const otherHeading = other.querySelector('[data-plp-faq-row-heading]');
            const otherContent = other.querySelector('[data-plp-faq-row-content]');
            if (otherHeading) otherHeading.classList.remove('plp-faq-item__heading--open');
            if (otherContent) otherContent.style.display = 'none';
          });

          heading.classList.toggle('plp-faq-item__heading--open', !isOpen);
          content.style.display = isOpen ? 'none' : '';
        });
      });
    }
  }

  customElements.define('plp-faq-accordion', PlpFaqAccordion);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["plp-hero-v1"]) return;
  try {
    
  class PlpHeroV1 extends HTMLElement {
    connectedCallback() {
      this.querySelectorAll('[data-plp-scroll-to]').forEach((link) => {
        link.addEventListener('click', (event) => {
          const target = document.querySelector(link.dataset.plpScrollTo);
          if (!target) return;
          event.preventDefault();
          const offset = window.innerWidth <= 767 ? 50 : 70;
          window.scrollTo({
            top: target.getBoundingClientRect().top + window.scrollY - offset,
            behavior: 'smooth'
          });
        });
      });
    }
  }

  customElements.define('plp-hero-v1', PlpHeroV1);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["plp-hero-v2"]) return;
  try {
    
  class PlpHeroV2 extends HTMLElement {
    connectedCallback() {
      const slides = Array.from(this.querySelectorAll('[data-plp-gallery-slide]'));
      const thumbs = Array.from(this.querySelectorAll('[data-plp-gallery-thumb]'));
      const prevBtn = this.querySelector('[data-plp-gallery-prev]');
      const nextBtn = this.querySelector('[data-plp-gallery-next]');
      let currentSlide = 0;

      const setSlide = (index) => {
        if (!slides.length) return;
        currentSlide = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => slide.classList.toggle('plp-hero-v2__slide--active', i === currentSlide));
        thumbs.forEach((thumb, i) => thumb.classList.toggle('plp-hero-v2__thumb--active', i === currentSlide));
      };

      thumbs.forEach((thumb, i) => {
        thumb.addEventListener('click', () => setSlide(i));
      });

      if (prevBtn) prevBtn.addEventListener('click', () => setSlide(currentSlide - 1));
      if (nextBtn) nextBtn.addEventListener('click', () => setSlide(currentSlide + 1));

      const stage = this.querySelector('[data-plp-gallery-stage]');

      const buildPreviews = () => {
        if (!stage) return;
        const stageRect = stage.getBoundingClientRect();
        if (!stageRect.width || !stageRect.height) return;
        thumbs.forEach((thumb, i) => {
          const host = thumb.querySelector('[data-plp-thumb-preview]');
          const original = slides[i] && slides[i].querySelector('.plp-hero-v2__info-slide');
          if (!host || !original) return;
          host.innerHTML = '';
          const clone = original.cloneNode(true);
          clone.style.position = 'absolute';
          clone.style.top = '0';
          clone.style.left = '0';
          clone.style.width = stageRect.width + 'px';
          clone.style.height = stageRect.height + 'px';
          clone.style.pointerEvents = 'none';
          host.appendChild(clone);
          const hostRect = host.getBoundingClientRect();
          const scale = hostRect.width / stageRect.width;
          clone.style.transformOrigin = 'top left';
          clone.style.transform = `scale(${scale})`;
        });
      };

      requestAnimationFrame(buildPreviews);

      let resizeTimer;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(buildPreviews, 200);
      });

      this.querySelectorAll('[data-plp-faq-toggle]').forEach((button) => {
        button.addEventListener('click', () => {
          const item = button.closest('[data-plp-faq-item]');
          if (item) item.classList.toggle('plp-hero-v2__faq-item--active');
        });
      });

      const form = this.querySelector('[data-plp-cart-form]');
      const addButton = this.querySelector('[data-plp-add-to-cart]');
      const message = this.querySelector('[data-plp-form-message]');
      if (form && addButton) {
        form.addEventListener('submit', (event) => {
          if (addButton.disabled) return;
          const kachingInput = form.querySelector('[name="id"]');
          if (kachingInput) return;
          event.preventDefault();
          if (message) message.textContent = 'Select a package above to continue.';
        });
      }
    }
  }

  customElements.define('plp-hero-v2', PlpHeroV2);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["plp-package"]) return;
  try {
    
  class PlpPackage extends HTMLElement {
    connectedCallback() {
      this.message = this.querySelector('[data-plp-package-message]');
    }
  }

  customElements.define('plp-package', PlpPackage);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["plp-timeline"]) return;
  try {
    
  class PlpTimeline extends HTMLElement {
    connectedCallback() {
      this.content = this.querySelector('[data-plp-timeline-content]');
      this.drawLine = this.querySelector('[data-plp-timeline-draw-line]');
      if (!this.content || !this.drawLine) return;

      this.onScroll = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.onScroll();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
    }

    onScroll() {
      const timelineDistance = this.content.getBoundingClientRect().top + window.scrollY;
      const windowDistance = window.scrollY;
      const windowHeight = window.innerHeight / 2;
      const greyLineHeight = this.querySelector('.plp-timeline__default-line').offsetHeight;

      if (windowDistance >= timelineDistance - windowHeight) {
        const line = windowDistance - timelineDistance + windowHeight;
        if (line <= greyLineHeight) {
          this.drawLine.style.height = line + 'px';
        }
      }
    }
  }

  customElements.define('plp-timeline', PlpTimeline);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  class ProductBuyBox extends HTMLElement {
    connectedCallback() {
      this.stageImage = this.querySelector('[data-role="stage-image"]');
      this.counter = this.querySelector('[data-role="counter"]');
      this.thumbs = Array.from(this.querySelectorAll('[data-role="thumb"]'));
      this.priceEl = this.querySelector('[data-role="price"]');
      this.variantIdInput = this.querySelector('[data-role="variant-id"]');
      this.submitBtn = this.querySelector('[data-role="submit"]');
      this.qtyInput = this.querySelector('[data-role="qty-input"]');
      this.form = this.querySelector('[data-role="form"]');
      this.formMessage = this.querySelector('[data-role="form-message"]');
      this.index = 0;

      const prev = this.querySelector('[data-role="prev"]');
      const next = this.querySelector('[data-role="next"]');
      if (prev) prev.addEventListener('click', () => this.setIndex(this.index - 1));
      if (next) next.addEventListener('click', () => this.setIndex(this.index + 1));

      this.thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => this.setIndex(parseInt(thumb.dataset.index, 10)));
      });

      this.querySelectorAll('[data-role="variant-input"]').forEach((input) => {
        input.addEventListener('change', () => this.applyVariant(input));
      });

      const decrease = this.querySelector('[data-role="qty-decrease"]');
      const increase = this.querySelector('[data-role="qty-increase"]');
      if (decrease) decrease.addEventListener('click', () => this.adjustQty(-1));
      if (increase) increase.addEventListener('click', () => this.adjustQty(1));

      if (this.form) {
        this.form.addEventListener('submit', (event) => this.handleSubmit(event));
      }
    }

    setIndex(newIndex) {
      const count = this.thumbs.length;
      if (!count) return;
      this.index = (newIndex + count) % count;
      const thumb = this.thumbs[this.index];
      if (this.stageImage && thumb) {
        this.stageImage.src = thumb.dataset.full;
        const thumbImg = thumb.querySelector('img');
        if (thumbImg) this.stageImage.alt = thumbImg.alt;
        thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
      this.thumbs.forEach((t, i) => t.classList.toggle('product-hero__thumb--active', i === this.index));
      if (this.counter) this.counter.textContent = (this.index + 1) + ' / ' + count;
    }

    applyVariant(input) {
      if (this.priceEl) this.priceEl.innerHTML = this.buildPriceHtml(input.dataset.priceHtml, input.dataset.comparePriceHtml);
      if (this.variantIdInput) this.variantIdInput.value = input.value;
      const available = input.dataset.available === 'true';
      if (this.submitBtn) {
        this.submitBtn.disabled = !available;
        this.submitBtn.textContent = available
          ? this.submitBtn.dataset.labelAvailable
          : this.submitBtn.dataset.labelUnavailable;
      }
    }

    // Mirrors snippets/price.liquid's own markup/classes exactly, so a
    // variant switch and the initial server render look identical —
    // comparePriceHtml is only ever a plain already-money-formatted
    // string (or empty), never raw variant data, so no separate
    // escaping is needed here.
    buildPriceHtml(priceHtml, comparePriceHtml) {
      let html = '<span class="price__amount">' + (priceHtml || '') + '</span>';
      if (comparePriceHtml) {
        html += '<del class="price__compare-at">' + comparePriceHtml + '</del>';
      }
      return html;
    }

    adjustQty(delta) {
      if (!this.qtyInput) return;
      const next = Math.max(1, (parseInt(this.qtyInput.value, 10) || 1) + delta);
      this.qtyInput.value = next;
    }

    async handleSubmit(event) {
      event.preventDefault();
      if (!this.submitBtn || this.submitBtn.disabled) return;

      const originalLabel = this.submitBtn.dataset.labelAvailable;
      this.submitBtn.disabled = true;
      this.submitBtn.textContent = this.submitBtn.dataset.labelAdding;
      if (this.formMessage) this.formMessage.textContent = '';

      try {
        const response = await fetch(this.form.action, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(this.form)
        });
        const data = await response.json();
        if (!response.ok) {
          throw new Error(data.description || data.message || 'add_to_cart_failed');
        }

        const cartResponse = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
        const cart = await cartResponse.json();
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { itemCount: cart.item_count } }));

        this.submitBtn.textContent = this.submitBtn.dataset.labelAdded;
        if (this.formMessage) this.formMessage.textContent = this.submitBtn.dataset.labelAdded;
      } catch (error) {
        this.submitBtn.textContent = this.submitBtn.dataset.labelError;
        if (this.formMessage) this.formMessage.textContent = this.submitBtn.dataset.labelError;
      } finally {
        setTimeout(() => {
          this.submitBtn.textContent = originalLabel;
          this.submitBtn.disabled = false;
          if (this.formMessage) this.formMessage.textContent = '';
        }, 1800);
      }
    }
  }

  customElements.define('product-buy-box', ProductBuyBox);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review-wall"] && !Shopify.designMode) return;
  try {
    
  class ReviewWall extends HTMLElement {
    connectedCallback() {
      const button = this.parentElement.querySelector('[data-role="show-more"]');
      if (!button) return;
      button.addEventListener('click', () => {
        this.setAttribute('data-expanded', 'true');
        button.remove();
      });
    }
  }
  customElements.define('review-wall', ReviewWall);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-rail"] && !Shopify.designMode) return;
  try {
    
  class VideoRail extends HTMLElement {
    connectedCallback() {
      const row = this.closest('.video-rail__row');
      if (!row) return;
      const prev = row.querySelector('[data-role="prev"]');
      const next = row.querySelector('[data-role="next"]');
      if (prev) prev.addEventListener('click', () => this.scrollByDirection(-1));
      if (next) next.addEventListener('click', () => this.scrollByDirection(1));

      this.videos = Array.from(this.querySelectorAll('video'));
      this.videos.forEach((video) => {
        video.addEventListener('play', () => this.pauseOthers(video));
      });
    }

    pauseOthers(current) {
      this.videos.forEach((video) => {
        if (video !== current) video.pause();
      });
    }

    scrollByDirection(dir) {
      this.videos.forEach((video) => video.pause());
      this.scrollBy({ left: dir * this.clientWidth, behavior: 'smooth' });
    }
  }
  customElements.define('video-rail', VideoRail);

  } catch(e) { console.error(e); }
})();
})();
